import { CHIPS } from '../lib/products';

const SPOTS = [
  { i: 0, cls: 'w-16 md:w-28 -left-4 top-[8%]', r: -20, t: 8 },
  { i: 1, cls: 'w-12 md:w-20 right-[4%] top-[6%]', r: 25, t: 9 },
  { i: 2, cls: 'w-10 md:w-16 left-[10%] bottom-[8%]', r: 40, t: 7 },
  { i: 3, cls: 'w-12 md:w-24 -right-3 bottom-[14%]', r: -35, t: 10 },
  { i: 4, cls: 'w-8 md:w-12 left-[45%] top-[3%]', r: 10, t: 6 },
];
const EDGES = [
  { i: 0, cls: 'hidden md:block w-20 -left-5 top-[10%]', r: -20, t: 8 },
  { i: 3, cls: 'hidden md:block w-20 -right-4 top-[12%]', r: 30, t: 9 },
  { i: 2, cls: 'hidden md:block w-14 -left-2 bottom-[10%]', r: 45, t: 7 },
];

export default function FloatingChips({ count = 5, edges = false, className = '' }) {
  const spots = edges ? EDGES : SPOTS.slice(0, count);
  return (
    <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} data-testid="floating-chips">
      {spots.map((s) => (
        <img key={s.i} src={CHIPS[s.i]} alt="" loading="lazy" className={`absolute chip-drift opacity-90 ${s.cls}`} style={{ '--r': `${s.r}deg`, '--t': `${s.t}s` }} />
      ))}
    </div>
  );
}
